import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const hatena: Platform = {
  id: 'hatena',
  name: 'はてなブックマーク',
  iconIndex: PlatformRegistry.hatena.index,
  color: PlatformRegistry.hatena.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://b.hatena.ne.jp/add', {
      mode: 'confirm',
      url: content.url,
      title: content.title,
    });
  },
};

